import type { RentalAssetData } from '../../domain/model/rental-asset.types';
import { LicensePlateView } from '../../components/LicensePlateView';
import type { AccountRental, ExternalRental } from '../../domain/model/rentals.types';
import Rioglyph from '@rio-cloud/rio-uikit/Rioglyph';

type VehicleGridProps = {
    rentalAssetData: RentalAssetData[];
    sold?: boolean;
};

const renterDisplayName = (rentalAssetData: RentalAssetData): string | null =>
    rentalAssetData.renterAccountDisplayName ||
    (rentalAssetData.rental as AccountRental)?.renterAccountId ||
    (rentalAssetData.rental as ExternalRental)?.renterIdentifier;

const VehicleGrid = ({ rentalAssetData, sold }: VehicleGridProps) => (
    <div>
        {rentalAssetData.map(rentalAsset => (
            <div key={rentalAsset.asset.assetId} className='position-relative'>
                <div className='padding-y-10 padding-x-15 rounded bg-lightest text-size-14'>
                    <div className='display-flex align-items-center gap-10'>
                        <div className='display-flex align-items-center gap-10 flex-1-1-0'>
                            <div className='display-flex align-items-center gap-5 width-150'>
                                <Rioglyph icon={`rioglyph-${rentalAsset.asset.type}`} />
                                <span className='text-medium'>{rentalAsset.asset.vehicleName}</span>
                            </div>
                            {rentalAsset.asset?.vin && (
                                <div className='display-flex align-items-center gap-5'>
                                    <span className='text-medium'>VIN</span>
                                    {rentalAsset.asset?.vin}
                                </div>
                            )}
                        </div>
                        <div className='width-100'>
                            <LicensePlateView asset={rentalAsset.asset} />
                        </div>
                    </div>
                    {sold && (
                        <div className='display-flex align-items-center gap-5'>
                            <span className='rioglyph rioglyph-arrow-right' />
                            <b>{renterDisplayName(rentalAsset)}</b>
                        </div>
                    )}
                </div>
            </div>
        ))}
    </div>
);

export default VehicleGrid;
